module.exports = __webpack_public_path__ + "static/media/total.56d31ff1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/total.svg
// module id = 402
// module chunks = 7